/**
 * Get specific states from redux here
 */

export const firebaseUserRx = (state) => state.persist.firebaseUser;
